const useCaptchaValidation = () => {
    return new Promise(resolve => {
        window.grecaptcha.ready(() => {
            window.grecaptcha
                .execute(process.env.GATSBY_GOOGLE_SITE_KEY, {
                    action: 'submit_greeting_form',
                })
                .then(token => {
                    resolve(token);
                });
        });
    });
};
export default useCaptchaValidation;
